module.exports = __webpack_public_path__ + "static/media/stop.eb506239.svg";